export default {
  meta: {
    title: '场地管理（慢闪店）'
  }
};
